import Api from "./api";
import { map } from "rxjs/operators";

export class ChannelApi {
    static getChannel(channel: string) {
        return Api.get(
            `ux-canales-vida-ley-clientes-vda/ecommerce-vida-ley-cliente/soporte-ti/v1/products/LIVE_LAW/url/${channel}`
        ).pipe(map(({ response }) => response));
    }
}
